import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import classNames from 'classnames'

import mobileImage from '../../../assets/images/auth/join-community-mobile.webp'
import { getCommunity } from '../../../actions/communitiesActions'

import classes from './JoinCommunityPage.module.scss'
import Loader from '../../common/loader/legacy-loaders/Op36Loader-web'
import ButtonLink from '../../common/buttons/ButtonLink'

const JoinCommunityPage = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const params = useParams()

  const community = useSelector(state => state.community)
  const [loader, setLoader] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    setLoader(true)
    dispatch(getCommunity(params.id))
      .catch(_ => setError('Community does not exist.'))
      .finally(_ => setLoader(false))
  }, [dispatch, params.id])

  const onAccept = () => {
    localStorage.setItem('communityId', community.id)

    navigate('/', { replace: true })
  }


  return (
    <div className={classNames(classes.joinCommunityPage, 'd-flex')}>
      <div className={classNames(classes.mainCard, 'd-flex flex-column justify-content-center align-items-center m-auto')}>
        {loader ? (
          <Loader message='loading community' />
        ) : (
          <>
            {error ? (
              <div className='d-flex flex-column w-100 h-100'>
                <h2>Community not found!</h2>

                <h4>{error}</h4>

                <div className='w-100 d-flex justify-content-center align-items-center mt-auto'>
                  <ButtonLink navigateTo={'/'} className={classes.actionLink}>
                    Log In
                  </ButtonLink>
                </div>
              </div>
            ) : (
              <div className='h-100 d-flex flex-column'>
                <div className='row'>
                  <main className='col-12 col-md-7 d-flex flex-column justify-content-center'>
                    <header className='mb-5'>
                      <div className='round-image-wrapper mb-3'>
                        <img className='round-image' src={community.photo.file_url} alt='community avatar' />
                      </div>

                      <h4>{community.name}</h4>
                    </header>

                    <h2 className='mb-2'>Hello!</h2>
                    <h4 className='mb-4'>Welcome to the Operation 36 Program at {community.name}</h4>

                    <p className={classes.text}>Join this community by clicking the link below.</p>
                  </main>

                  <aside className='col-12 col-md-5 text-center mt-3 mt-md-0'>
                    <img src={mobileImage} alt='mobile' className={classes.mobileImage}></img>
                  </aside>
                </div>

                <div className='w-100 d-flex justify-content-center align-items-center mt-auto'>
                  <button type='button' onClick={onAccept} className={classNames(classes.acceptButton, 'btn btn-primary')}>
                    Join Community
                  </button>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default JoinCommunityPage
